<template>
  <div class="content">
    <v-form  v-model="valid"
             validation
             ref="form"
             class="forms">
    <img style="margin-top: 25px;width: 150px" src="../../../assets/lotus-logo.svg" alt="">
    <p  style="font-size: 25px;font-family: anjoman;font-weight: bold;margin-top: 44px">ادمین لوتوس مال</p>
    <v-text-field
      v-model="userName"
      style="direction: rtl;width: 475px;height: 57px;font-family: anjoman;font-weight: normal;font-size: 1.2rem;margin-top: 48px"
      outlined
      rounded
      placeholder="نام کاربری"
      prepend-inner-icon="mdi-account"
      :rules="[userNameRules]"
      required
      class="user-name"
    ></v-text-field>
    <v-text-field
      v-model="password"
      style="direction: rtl;width: 475px;height: 57px; font-family: anjoman;font-weight: normal;font-size: 1.2rem;margin-top: 36px"
      type="password"
      outlined
      rounded
      class="password"
      placeholder="رمز عبور"
      prepend-inner-icon="mdi-lock"
      :rules="[passwordRules]"
      required
    ></v-text-field>
    <p v-show="token && click" style="color: red;margin-top: 10px;font-family: anjoman;font-weight: 200;font-size: 1.2rem">نام کاربری یا رمز عبور اشتباه است</p>
    <v-btn
      style="font-family: anjoman;font-weight: normal;font-size: 1.68rem;margin-top: 64px"
      class="white--text "
      depressed
      rounded
      color="#E72480"
      width="471"
      height="57"
      :disabled="!valid"
      :loading="loading"
      @click="login"
    >
      ورود
    </v-btn>
    </v-form>
  </div>

</template>

<script>

  export default {

        name: "loginPage",
      data : ()=>({
        password:'',
        userName:'',
        valid: true,
        click : false,
        loading:false,
        token : localStorage.getItem('token'),
        userNameRules: v =>{
          if(v !== '' )
          {
            return true
          }
          else
          {
            return `لطفا نام کاربری را وارد کنید.`
          }
        },
        passwordRules: v =>{
          if(v !== '' && v.length >= 6
          )
          {
            return true
          }
          else
          {
            return `نام کاربری وارد شده باید حداقل به طول ۶ باشد.`
          }
        },
      }),
      computed :{
      },
    methods: {
      async login (){
        this.loading = true
        const username = this.userName
        const password = this.password
        await this.$store.dispatch('login', { username, password }).then(() => {
          if(localStorage.getItem('lotusToken') )
          {
            this.$router.push('/').catch(()=>{})
          }
          else{
            this.click = true
          }
          this.loading = false
        }).catch(()=>{
          this.token = true
          this.click = true
          this.loading = false
        })
        this.loading = false

      }
    },

  }
</script>

<style>
  .password .v-text-field__slot input{
    background-color: transparent!important;
  }
  .user-name .v-text-field__slot input{
    background-color: transparent !important;
  }
  .content .v-messages__message{
    color: red;
    display: flex;
  }
  .login .v-text-field--outlined fieldset {
    color: #0D58AD !important;
  }
</style>
<style scoped>
 .forms{
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
 }
  .content{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
  }
</style>

